import React from 'react';
import { Button, IconType, Notification } from 'ui-toolkit';
import '../../scss/_NotificationLenderPremiumConditionalRate.scss';

interface INotificationLenderPremiumConditionalRateProp {
  onCheckNowClick: () => void;
}

export default class NotificationLenderPremiumConditionalRate extends React.PureComponent<INotificationLenderPremiumConditionalRateProp> {
  public render() {
    const { onCheckNowClick } = this.props;
    return (
      <div className="notification-lender-premium-conditional-rate">
        <Notification icon={IconType.InfoLine} type="warning">
          Lender’s Policy may be eligible for a discount. &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <Button
            className="notification-lender-premium-conditional-rate__check-now"
            onClick={onCheckNowClick}
            intent="secondary"
            isInline
          >
            Check Now
          </Button>
        </Notification>
      </div>
    );
  }
}
